import { createAction } from '../../utils/redux'
import { ActionsUnion } from '../../utils/types'
import { PaymentTemplate } from './types'

// actions
export const FETCH_PAYMENT_TEMPLATES = 'paymentTemplate/FETCH_PAYMENT_TEMPLATES'
export const FETCH_PAYMENT_TEMPLATES_SUCCESS = 'paymentTemplate/SUCCESS'
export const FETCH_PAYMENT_TEMPLATES_FAIL = 'paymentTemplate/FETCH_PAYMENT_TEMPLATES_FAIL'

export const PaymentTemplateActions = {
  fetchPaymentTemplates: () => createAction(FETCH_PAYMENT_TEMPLATES),
  fetchPaymentTemplatesSuccess: (paymentTemplates: PaymentTemplate[]) =>
    createAction(FETCH_PAYMENT_TEMPLATES_SUCCESS, paymentTemplates)
}

export type PaymentTemplateActions = ActionsUnion<typeof PaymentTemplateActions>
